import { GRAPH_TRENDING_TAGS_QUERIES } from 'graphql/trending-tags'
import type {
  TrendingTagsQueriesName,
  TrendingTagsQueriesData,
  TrendingTagsQueriesVariables,
} from 'graphql/trending-tags/types'
import { buildQueryHook } from 'lib/apollo-client/builders'

export const useTrendingTagsQuery = buildQueryHook<
  TrendingTagsQueriesName,
  TrendingTagsQueriesVariables,
  TrendingTagsQueriesData
>(GRAPH_TRENDING_TAGS_QUERIES)
